// extracted by mini-css-extract-plugin
export var cartItem = "_q-3";
export var drawerContent = "_q-0";
export var emptyCart = "_q-2";
export var fadeIn = "_q-4";
export var imagePlaceholder = "_q-6";
export var itemImage = "_q-5";
export var itemsContainer = "_q-1";